import uuid from 'uuid/v1'

import * as excelConstants from '../../../constants/General/Excel'
import { updateTab, addActionInTab } from "../../Tabs"
import { updateTemplateAcions} from "../../../../../../redux/actions/template"
export const addDeleteColumn = (parentId = null) => {
  return (dispatch, getState) => {

    let action = {
      id: uuid(),
      type: "deletecolumn",

      label: "Delete Column",
      key: "deletecolumn",
      isShow: true
    }
    
    dispatch(updateTemplateAcions(action))
  }
}

export const editDeleteColumn = (payload, actionId = null) => {
  return (dispatch, getState) => {
    // let { tabs, currentTab } = getState()
    // let tab = tabs[currentTab]
    // // please refer to the appendRange.js
    // let excelAction = tab["actions"][actionId ? actionId : tab.currentAction]
    // let temp = {
    //   ...excelAction,
    //   ...payload
    // }
    // if ((temp.path != "" && temp.path != ".") && temp.sheetName && temp.colNum != "") {
    //   temp.status = true
    // } else {
    //   temp.status = false
    // }
    // let instruction = `api_config = {method:'DELETE', header:[], body:{}}
    //                    api ${remote.process.env.RPA_PYTHON_API}/api/v1/column?filePath=${temp.path}&sheetName=${temp.sheetName}&columnNumber=${temp.colNum}\n
    //                    echo api_json.data`
    // tab["actions"][actionId ? actionId : tab.currentAction] = {
    //   ...temp,
    //   instruction: instruction,
    //   description: `delete ${temp.colNum} of ${temp.sheetName} in ${temp.path}`
    // }
    // dispatch(updateTab(tab))
  }
}
